import { TableBody, TableCell, TableFooter, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";
import { formatDate } from "../../../helpers/dateFormatter";

export const GLTransactionsReportTable: React.FC<BaseTablePropsType> = ({
	rows,
	hasFooter = false,
}) => {
	const glTransactionsTableHeaders = [
		"Date & Time",
		"Narration",
		"Amount CR",
		"Amount DR",
		"Total Amount",
	];

	const summation = rows?.reduce(
		(acc, row) => {
			if (row.entryType === "cr") acc.totalCR += row.amount || 0;
			if (row.entryType === "dr") acc.totalDR += row.amount || 0;
			acc.grandAmount += row.totalAmount ?? 0;
			return acc;
		},
		{ totalCR: 0, totalDR: 0, grandAmount: 0 }
	);

	return (
		<BaseTable headers={glTransactionsTableHeaders}>
			<TableBody>
				{rows?.map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell>{formatDate(row?.createdAt, true)}</TableCell>
							<TableCell>{row?.description}</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.entryType === "cr" ? row?.amount : 0)}
							</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.entryType === "dr" ? row?.amount : 0)}
							</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.totalAmount ?? 0)}
							</TableCell>
						</TableRow>
					);
				})}
			</TableBody>
			{hasFooter && (
				<TableFooter>
					<TableRow>
						<TableCell colSpan={2}>Grand Total</TableCell>
						<TableCell>
							{formatAmountDisplay(summation?.totalCR ?? 0)}
						</TableCell>
						<TableCell>
							{formatAmountDisplay(summation?.totalDR ?? 0)}
						</TableCell>
						<TableCell>
							{formatAmountDisplay(summation?.grandAmount ?? 0)}
						</TableCell>
					</TableRow>
				</TableFooter>
			)}
		</BaseTable>
	);
};
